/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import ViewOrganizationsTable from './ViewOrganizationsTable';
import { selectOrgs } from 'selectors/entities/organizations';

const mapStateToProps = state => ({
  data: selectOrgs(state),
});

const ViewOrganizationsContainer
  = connect(mapStateToProps)(ViewOrganizationsTable);

export default ViewOrganizationsContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/ViewOrganizations/ViewOrganizationsTable/index.js